import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { affinityVariableEPlusContent } from './affinityVariableEPlus';
import { DETAILS_CONTENT_KEYS, IPlanContent, KeyDetailsItem } from '../typings/planContent.types';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const originPartnerKeyDetails =
  affinityVariableEPlusContent.content.keyDetails?.defaultState?.defaultFuel.filter(
    (item: KeyDetailsItem) => item.contentKey !== DETAILS_CONTENT_KEYS.GreenOptions
  ) ?? [];

export const originPartnerAffinityVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Partner Affinity Variable']),
  content: {
    ...affinityVariableEPlusContent.content,
    keyDetails: {
      defaultState: {
        defaultFuel: originPartnerKeyDetails,
        dual: [
          ...originPartnerKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: '100% GreenPower add-on included in this plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription: '100% GreenPower add-on included in this plan',
          },
        ],
        electricity: [
          ...originPartnerKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: '100% GreenPower included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription: '100% GreenPower included in the plan',
          },
        ],
        gas: [...originPartnerKeyDetails],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog(),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-partner-affinity-variable/',
      },
    },
  },
};
